import React from 'react';
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/theme.css';

import FabricSelector from './components/fabricSelector';

const container = document.getElementById('mtm-fabric-selector');
if (container) {
  const root = createRoot(container);
  root.render(
    <>
      <FabricSelector />
    </>
  );
}
